import $ from 'jquery';
import processInclude from '../util';
import scrollTo from '../util/scrollTo';
import { updateComponent } from '../util/domutils';
import clientSideValidation from '../components/clientSideValidation';
import { startSpinner } from '../util/fetchutils';
import { loadFormErrors } from './formErrors';

const tabletBreakpoint = 769;
const mobileBreakpoint = 767;

export const SELECTORS = {
  HEADER: '.checkout-header',
  CONTENT: '.checkout',
  PAYMENTFORM: '.payment-container',
  ERRORCONTENT: '.checkout-step__errors',
  STEP_FORM: '.checkout-step__form',
  SHIPPING_FORM: '.checkout-shipping__form',
  BILLING_FORM: '.checkout-billing__form',
  SUMMARY_FORM: '.checkout-summary__form',
  STEP_CONTENT: '.page',
  SHIPPING_TYPE: {
    TYPE: '.checkout-shipping__type',
    CURRENT_TYPE: '.checkout-shipping__type.active',
  },
  SAVED_ADDRESS: {
    SHIPMENT_SELECTOR: '.saved-addresses',
    SAVED_ADDRESS_CONTAINER: '.saved-addresses__pane',
    SAVED_ADDRESS_INPUT: '.saved-addresses__address-input',
  },
  SHIPPING_ADDRESS: {
    FIELDS: '.checkout-shipping__address',
    NEW_FIELDS: '.saved-addresses__new-fields',
    SAVE_TOGGLE: '.checkout-shipping__shipment__save-address',
    get LINE1() { return `${this.FIELDS} #addressOne`; },
    get STATE() { return `${this.FIELDS} #stateCode`; },
    get CITY() { return `${this.FIELDS} #city`; },
    get POSTAL_CODE() { return `${this.FIELDS} #postalCode`; },
  },
  SHIPPING_METHODS: {
    CONTAINER: '.checkout-shipping__method-list',
    METHOD: '.checkout-shipping__method',
    METHOD_INPUT: '.checkout-shipping__method-input',
  },
  GIFT: {
    CONTAINER: '.checkout-shipping__gift',
    INPUT: '.checkout-shipping__gift-input',
    MESSAGE_INPUT: '.checkout-shipping__gift-message',
    MESSAGE_TEXT_AREA: '#giftMessage',
    SYMBOLS_LEFT: '.checkout-shipping__symbols-left-count',
    GIFT_PACKAGING_CHECKBOX: '.checkout-shipping__gift-content',
  },
  BILLING_ADDRESS: {
    CARD: '.checkout-billing__address-card',
    SAME_AS_SHIPPING: '.checkout-billing__copy-shipping-input',
  },
  PAYMENT_METHODS: {
    GIFT_CARD_FORM: '.checkout-billing__gift-card-form',
    GIFT_CARD_FORM_LIST: '.giftcard-payment',
    CREDIT_CARD_FORM: '.checkout-billing__credit-card-form',
    INPUT: '.checkout-billing__payment-input',
    CONTENT: '.checkout-billing__payment-content',
    CREDIT_CARD: {
      DATE: '#expirationDate',
      MONTH: '#expirationMonth',
      YEAR: '#expirationYear',
      NEW_CVV: '.checkout-billing__cvv--new',
      SAVED_CVV: '.checkout-billing__cvv--saved',
      CVV_TOOLTIP: '.checkout-billing__cvv__tooltip-wrapper',
      NEW_LABEL: '.checkout-billing__payment-selector--CREDIT_CARD',
      SAVED_LABEL: '.checkout-billing__payment-selector--SAVED_CREDIT_CARD',
      SAVED_FORM: '.checkout-billing__payment-form--SAVED_CREDIT_CARD',
      SAVED_DROPDOWN_CONTAINER: '.saved-cards__container',
      SAVED_DROPDOWN: '#savedCards',
      NUMBER_GROUP: '.checkout-billing__credit-card-number',
      DATE_GROUP: '.checkout-billing__credit-card-expiry',
      NEW_OPTION: '.checkout-billing__payment--CREDIT_CARD',
    },
    APPLE_PAY: {
      OPTION: '.checkout-billing__payment--DW_APPLE_PAY',
    },
  },
  SUBMIT: '.checkout-billing__submit-btn',
  ERRORS: {
    CONTAINER: '.checkout-step__errors',
    CONTENT: '.error-summary',
  },
  SUMMARY: '.summary',
  PAYMENTSUMMARY: '.paymentTotalSummary',
};

export const EVENTS = {
  SAVED_ADDRESS: {
    ADDRESS_SELECTED: 'savedAddress:selected',
  },
  BILLING: {
    USE_SHIPPING_AS_BILLING_TOGGLED: 'useShippingAsBilling:toggle',
  },
  ADYENCONTENT: 'adyen3dsModalContent',
  UPDATEVIEW: 'checkout:updatedview',
  TRIGGER_SHIPPING_VALIDATION: 'checkout:shippingValidate',
};

const showComponent = (selector) => {
  const component = document.querySelector(selector);

  if (component) {
    component.classList.remove('d-none');
    scrollTo(component);
  }
};

const hideComponent = (selector) => {
  const component = document.querySelector(selector);

  if (component) {
    component.classList.add('d-none');
  }
};

const checkoutContent = () => {
  let checkoutShippingFormSubmit;
  const addressContent = document.querySelector('#address-content');
  const storeContent = document.querySelector('#store-content');
  const checkoutRedesign = document.querySelector('.checkout-redesign');
  const hubboxContainer = document.querySelector('.hubbox-container');
  const collectPaymentDetails = document.querySelector('.collect-payment-details');
  const paymentContainer = document.querySelector('.payment-container');

  if (addressContent && addressContent.classList.contains('active')) {
    checkoutShippingFormSubmit = addressContent.querySelector('.checkout-shipping__form-submit-container');
    if (checkoutShippingFormSubmit) checkoutShippingFormSubmit.classList.add('d-none');
    if (checkoutRedesign) checkoutRedesign.classList.add('deliverypayment');
    checkoutRedesign.classList.remove('collectionpayment');
  }

  if (storeContent && storeContent.classList.contains('active')) {
    checkoutShippingFormSubmit = storeContent.querySelector('.checkout-shipping__form-submit-container');
    // eslint-disable-next-line jquery/no-class
    if (!$('.hubbox-container').hasClass('registeredUser')) {
      if (hubboxContainer) hubboxContainer.classList.add('d-none');
      if (collectPaymentDetails) collectPaymentDetails.classList.remove('d-none');
    }
    if (checkoutRedesign) checkoutRedesign.classList.add('collectionpayment');
    checkoutRedesign.classList.remove('deliverypayment');
    if (checkoutShippingFormSubmit) checkoutShippingFormSubmit.classList.add('d-none');
  }

  if (paymentContainer) paymentContainer.classList.remove('d-none');
  if (checkoutRedesign) checkoutRedesign.classList.add('paymentSection');
  const $dialCode = $('#billingdialcode');
  if ($dialCode) {
    // eslint-disable-next-line jquery/no-attr
    const allowedCountries = $dialCode.attr('allowedLocales');
    // eslint-disable-next-line jquery/no-attr
    const defaultCountryCode = $dialCode.attr('defaultCountryCode');
    const $onlyCountries = allowedCountries ? allowedCountries.split(',') : '';
    $('#billingdialcode').intlTelInput({
      allowDropdown: true,
      initialCountry: defaultCountryCode,
      formatOnDisplay: true,
      separateDialCode: true,
      page: 'checkout-page',
      onlyCountries: $onlyCountries,
      dropdownContainer: $('.country-dial-code'),
    });
  }

  document.querySelectorAll('.checkout-container form input').forEach((input) => {
    input.addEventListener('blur', () => {
      input.setCustomValidity('');
      if (!input.validity.valid) {
        // eslint-disable-next-line prefer-destructuring
        let validationMessage = input.validationMessage;
        input.classList.remove('is-valid');
        input.classList.add('is-invalid');
        input.closest('.form-group').classList.add('form-error');
        if (input.validity.patternMismatch && input.dataset.patternMismatch) {
          validationMessage = input.dataset.patternMismatch;
        }
        if ((input.validity.rangeOverflow || input.validity.rangeUnderflow) && input.dataset.rangeError) {
          validationMessage = input.dataset.rangeError;
        }
        if ((input.validity.tooLong || input.validity.tooShort) && input.dataset.rangeError) {
          validationMessage = input.dataset.rangeError;
        }
        if (input.validity.valueMissing && input.dataset.missingError) {
          validationMessage = input.dataset.missingError;
        }
        const formGroup = input.closest('.form-group');
        const feedbackElement = formGroup ? formGroup.querySelector('.invalid-feedback') : null;
        if (feedbackElement) {
          feedbackElement.textContent = validationMessage;
        }
      } else {
        input.classList.remove('is-invalid');
        if (input.value.length > 0) {
          input.classList.add('is-valid');
        } else {
          input.classList.remove('is-valid');
        }
        input.closest('.form-group').classList.remove('form-error');
      }
    });
  });
};

const appendEmptyStage = (selector, content) => {
  const component = document.querySelector(selector);

  if (component) {
    if (content && content.length) {
      const existingContainer = component.querySelector('.checkout-summary');
      if (existingContainer) {
        existingContainer.remove();
      }
      const container = document.createElement('div');
      container.innerHTML = content;
      component.appendChild(container);
    }
  }
};

const handleCreditCardExpiryErrors = (fieldErrors) => {
  const modifiedErrors = Object.assign(fieldErrors);

  const dateField = document.querySelector(SELECTORS.PAYMENT_METHODS.CREDIT_CARD.DATE);
  const monthField = document.querySelector(SELECTORS.PAYMENT_METHODS.CREDIT_CARD.MONTH);
  const yearField = document.querySelector(SELECTORS.PAYMENT_METHODS.CREDIT_CARD.YEAR);

  if (dateField && monthField && yearField) {
    const expiryErrors = Object.keys(modifiedErrors)
      .filter(name => name === monthField.name || name === yearField.name)
      .map(name => modifiedErrors[name]);

    if (expiryErrors.length) {
      modifiedErrors[dateField.name] = expiryErrors.join(' ');
    }
  }

  return modifiedErrors;
};

const processFieldErrors = fieldErrors => handleCreditCardExpiryErrors(fieldErrors);

const redirectTo = (redirectUrl) => {
  const stepForm = document.querySelector(SELECTORS.STEP_FORM);

  if (stepForm) {
    $(stepForm).spinner().start();
  }

  // Executing the redirect in the main thread can cause IE to hang when leaving
  // the site, e.g. to get to a payer auth page
  setTimeout(() => {
    window.location = redirectUrl;
  });
};

export const clientSideValidationUpdate = async () => {
  const shippingForm = document.querySelector(SELECTORS.SHIPPING_FORM);
  clientSideValidation.functions.clearForm(shippingForm, true);
};

export const reinitClientSideValidation = () => {
  processInclude(clientSideValidation);
};

export const isRedirectResponse = (content) => {
  if (content) {
    const errorUrl = content.error && content.redirectUrl;
    const paypalUrl = content.paypalProcessorResult && content.paypalProcessorResult.success && content.paypalBaseUrl;

    return content.continueUrl || paypalUrl || errorUrl;
  }

  return false;
};

/**
 * Handles backend responses that contain rendered content for checkout components
 *
 * @param {Object} content Content returned by an AJAX request
 */
export const updateView = async (content) => {
  if (content.continueUrl) {
    redirectTo(content.continueUrl);
    return;
  }

  if (content.paypalProcessorResult && content.paypalProcessorResult.success && content.paypalBaseUrl) {
    redirectTo(content.paypalBaseUrl + content.paypalProcessorResult.paypalToken);
    return;
  }

  if (content.error) {
    if (content.redirectUrl) {
      redirectTo(content.redirectUrl);
      return;
    }

    if (content.errorContent) {
      await updateComponent(SELECTORS.ERRORS.CONTENT, content.errorContent);
      showComponent(SELECTORS.ERRORS.CONTAINER);
    }

    if (content.fieldErrors) {
      if (content.fieldErrors.length) {
        content.fieldErrors.forEach((error) => {
          if (Object.keys(error).length) {
            loadFormErrors(document, processFieldErrors(error));
          }
        });
      }
    }
  } else {
    await updateComponent(SELECTORS.ERRORS.CONTENT, '');
    hideComponent(SELECTORS.ERRORS.CONTAINER);
  }

  if (content.addressSelectorContent) {
    await updateComponent(SELECTORS.SAVED_ADDRESS.SHIPMENT_SELECTOR, content.addressSelectorContent);
  }

  if (content.shippingMethodsContent) {
    await updateComponent(SELECTORS.SHIPPING_METHODS.CONTAINER, content.shippingMethodsContent);
    const shippingMethod = document.querySelector('#address-content .checkout-shipping__method');
    if (shippingMethod) {
      const $outerMost = $('.checkout-shipping__method').first();
      // eslint-disable-next-line jquery/no-find
      const $firstInput = $outerMost.find('input').first();
      // eslint-disable-next-line jquery/no-prop, jquery/no-is
      if ($firstInput.prop('disabled') && $('.checkout-shipping__method-input:checked').length === 0) {
        // eslint-disable-next-line jquery/no-prop
        $firstInput.prop('disabled', false);
        // eslint-disable-next-line jquery/no-trigger
        $firstInput.trigger('click');
      }
      if (document.querySelector('.checkout-shipping__selected-shipping-method_body')
          && document.querySelector('.paymentSection')) {
        const methodList = document.querySelector('.checkout-shipping__method-list');
        const selectedShippingMethod = document.querySelector('.checkout-shipping__selected-shipping-method-container');
        const selectedShippingMethodChange = document.querySelector('.checkout-shipping__methods-edit');
        if (methodList && selectedShippingMethod && selectedShippingMethodChange) {
          selectedShippingMethod.classList.add('showSelectedShippingMethod');
          selectedShippingMethodChange.classList.add('showSelectedShippingMethod');
          methodList.classList.add('showSelectedShippingMethod');
        }
      }
    }
    reinitClientSideValidation(); // Required for HubBox
  }

  if (content.giftContent) {
    await updateComponent(SELECTORS.GIFT.CONTAINER, content.giftContent);
  }

  if (content.billingAddressContent) {
    await updateComponent(SELECTORS.BILLING_ADDRESS.CARD, content.billingAddressContent);
    reinitClientSideValidation();
  }

  if (content.summaryContent) {
    await updateComponent(SELECTORS.SUMMARY, content.summaryContent);
    const $dataObject = $(content.paymentTotalSummary);
    if ($dataObject) {
      // eslint-disable-next-line jquery/no-html, jquery/no-find
      const subTotal = $dataObject.find('.grand-total-sum').html();
      $(SELECTORS.PAYMENTSUMMARY).empty().append($dataObject);
      $('.heading-grand-total-sum').empty().append(subTotal);
    }

    if (content.action !== 'CheckoutShippingServices-UpdateShippingMethodsList'
      && window.innerWidth > mobileBreakpoint && document.querySelector(SELECTORS.SUMMARY)
      && document.querySelector(SELECTORS.SUMMARY).classList.contains('collapse')) {
      document.querySelector(SELECTORS.SUMMARY).classList.remove('collapse');
    }
  }

  if (content.giftCardFormContent) {
    await updateComponent(SELECTORS.PAYMENT_METHODS.GIFT_CARD_FORM, content.giftCardFormContent);
  }

  if (content.giftCardFormContentSubmit) {
    const $giftData = $(content.giftCardFormContentSubmit);
    $(SELECTORS.PAYMENT_METHODS.GIFT_CARD_FORM_LIST).empty().append($giftData);
  }

  if (content.skipStepContent) {
    appendEmptyStage(SELECTORS.CONTENT, content.skipStepContent);
  } else if (content.stepContent) {
    const $urlSource = $('.checkout-shipping__form');
    const spinner = startSpinner($urlSource);
    const $dataObject = $(content.stepContent);
    // eslint-disable-next-line jquery/no-html, jquery/no-find
    const paymentData = $dataObject.find('.checkout-payment').html();
    // eslint-disable-next-line jquery/no-html, jquery/no-find
    const errorContent = $dataObject.find('.checkout-step__errors').html();
    // eslint-disable-next-line jquery/no-find, jquery/no-html
    const errorlength = $dataObject.find('.error-summary').html();
    $(SELECTORS.PAYMENTFORM).empty().append(paymentData);
    if (errorlength) {
      $(SELECTORS.ERRORCONTENT).empty().append(errorContent);
      document.querySelector('.checkout-step__errors').classList.remove('d-none');
      const parentContainer = document.querySelector('.checkout-redesign');
      scrollTo(parentContainer);
    }
    $('.payment-container .checkout-shipping__form').remove();
    reinitClientSideValidation();
    checkoutContent();
    const addressContent = document.querySelector('#address-content');
    const storeContent = document.querySelector('#store-content');
    setTimeout(() => {
      if (addressContent && addressContent.classList.contains('active')) {
        // eslint-disable-next-line jquery/no-css, jquery/no-class
        $('.checkout-shipping__types .store').removeClass('disabled-content');
      }
      if (storeContent && storeContent.classList.contains('active')) {
        // eslint-disable-next-line jquery/no-css, jquery/no-class
        $('.checkout-shipping__types .address').removeClass('disabled-content');
      }
      $(spinner).spinner().stop();
    }, 2000);
  }

  if (content.adyenAction) {
    document.dispatchEvent(new CustomEvent(EVENTS.ADYENCONTENT, {
      detail: {
        adyenAction: content.adyenAction,
        orderToken: content.orderToken,
      },
    }));
  }

  document.dispatchEvent(new CustomEvent(EVENTS.UPDATEVIEW, {
    detail: {
      stage: content.currentStage,
      action: content.action,
    },
  }));
};

export const attachCustomValidationEvents = () => {
  document.addEventListener(EVENTS.TRIGGER_SHIPPING_VALIDATION, () => {
    clientSideValidation.functions.validateForm(SELECTORS.SHIPPING_FORM);
  });
};

export const populateStickyOrderSummary = () => {
  const stickySummary = document.querySelector('.summary__container');
  const orderSummary = document.querySelector('.order-sticky-summary-overlay');
  const checkoutStep = document.querySelector('.checkout__step');
  const stickySummaryHeading = document.querySelector('#stickySummaryHeading');

  if (checkoutStep) {
    if (stickySummaryHeading && stickySummary
      && orderSummary && orderSummary.classList.contains('showStickySummary')
      && window.innerWidth < tabletBreakpoint) {
      checkoutStep.before(stickySummary);
      stickySummaryHeading.classList.add('collapse');
    } else {
      checkoutStep.after(stickySummary);
      if (stickySummaryHeading) { stickySummaryHeading.classList.remove('collapse'); }
    }
  }
};

export const setTitleDefaultValue = () => {
  const selectElement = document.querySelector('.checkout-step__billing-form #title');
  if (selectElement && selectElement.selectedIndex > 0) {
    // Set it to the first option
    selectElement.selectedIndex = 0;
  }
};

document.addEventListener(EVENTS.BILLING.USE_SHIPPING_AS_BILLING_TOGGLED, setTitleDefaultValue);

document.addEventListener('DOMContentLoaded', populateStickyOrderSummary);

$(document).on('click', '.summary__products-heading', () => {
  if (window.innerWidth < tabletBreakpoint) {
    setTimeout(() => {
      const summaryOverlay = document.querySelector('.order-sticky-summary-overlay');
      const summary = document.querySelector('.summary__container .summary');

      if (summary.classList.contains('collapsing')) {
        summaryOverlay.classList.toggle('showOverlay');
      }
    });
  }
});

window.addEventListener('resize', () => {
  populateStickyOrderSummary();
});
